// components/NextImage.tsx
import Image, { ImageProps } from "next/image";
import { useState, useEffect } from "react";
import clsx from "clsx";
import { getAssetPath } from "@/utils/assetPath";

interface NextImageProps extends ImageProps {
  fallbackSrc?: string;
  className?: string;
  placeholderBlur?: boolean;
}

const NextImage = ({
  src,
  fallbackSrc = "/assets/site/images/default.png",
  alt,
  className,
  placeholderBlur = false,
  ...props
}: NextImageProps) => {
  const [imgSrc, setImgSrc] = useState(getAssetPath(src));
  const [errored, setErrored] = useState(false);

  useEffect(() => {
    setImgSrc(getAssetPath(src));
    setErrored(false);
  }, [src]);

  const handleError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    if (props.onError) {
      props.onError(e);
    }
    if (!errored) {
      setImgSrc(getAssetPath(fallbackSrc));
      setErrored(true); // prevent infinite loop
    }
  };

  return (
    <Image
      {...props}
      src={imgSrc}
      alt={alt}
      className={clsx(className)}
      onError={handleError}
      // unoptimized
      placeholder={placeholderBlur ? "blur" : undefined}
      blurDataURL={
        placeholderBlur ? getAssetPath("/assets/site/images/placeholder.png") : undefined
      }
    />
  );
};

export default NextImage;
